/**
 * Live DataService — thin wrapper around real Firestore services and cloud functions.
 *
 * Each method delegates directly to the existing service layer.
 * This file exists so Dashboard can switch between live and demo
 * implementations through the DataService interface.
 */

import {
  listProviders,
  addProvider,
  saveProviderWithDefaults,
  deleteProvider,
} from '../services/providers'
import { listClinics, getClinic } from '../services/clinics'
import { listRecentChecks, verifyEligibility } from '../services/eligibilityChecks'
import { searchPayers } from '../services/payers'
import { updatePatient } from '../services/patients'
import type { DataService, VerifyEligibilityInput } from './types'
import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore'

export const liveDataService: DataService = {
  listProviders: (orgId, clinicId) => listProviders(orgId, clinicId),

  listClinics: (orgId) => listClinics(orgId),

  getClinic: (orgId, clinicId) => getClinic(orgId, clinicId),

  listRecentChecks: (orgId, pageSize, cursor, clinicId, sortDir, windowStart) =>
    listRecentChecks(
      orgId,
      pageSize,
      cursor as QueryDocumentSnapshot<DocumentData> | undefined,
      clinicId,
      sortDir,
      windowStart,
    ),

  verifyEligibility: (input: VerifyEligibilityInput) => verifyEligibility(input),

  searchPayers: (input) => searchPayers(input ?? {}),

  addProvider: (orgId, provider) => addProvider(orgId, provider),

  saveProviderWithDefaults: (orgId, fields, siblingUpdates, providerId) =>
    saveProviderWithDefaults(orgId, fields, siblingUpdates, providerId),

  deleteProvider: (orgId, id) => deleteProvider(orgId, id),

  updatePatient: (orgId, patientId, fields) => updatePatient(orgId, patientId, fields),
}
